import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface UsePurchaseCostsPermissionsReturn {
  canEdit: boolean
  canRead: boolean
}

export const usePurchaseCostsPermissions = (): UsePurchaseCostsPermissionsReturn => {
  const { hasPermissions } = usePermissionManager()

  const canEdit = hasPermissions([PermissionActionType.COST_MAINTENANCE])
  const canRead = hasPermissions([
    PermissionActionType.COST_MAINTENANCE,
    PermissionActionType.VENDOR_MAINTENANCE,
    PermissionActionType.VENDOR_VIEW,
  ])

  return { canEdit, canRead }
}
